export const desktopContentWidth = 834
export const mobileMaxWidth = desktopContentWidth + 48
export const mobileDialogMaxWidth = 772